angular.module('app.controllers').controller('DictionariesListCtrl', function ($scope, $state, $translate, $timeout, notify, api, dragularService) {
    // dane
    const DictionariesModel = api('dictionaries');

    $scope.dictionaries = [];
    $scope.dirty = {};

    $scope.loadList = () => {
        const info = notify.info($translate.instant('loading'));
        notify.global(1);
        DictionariesModel.list().then((response) => {
            $scope.dictionaries = angular.copy(response.data);
            info.close();
            notify.global(0);

            $timeout(() => {
                angular.forEach($scope.dictionaries, (dictionary) => {
                    const bag = `.dragular-${dictionary.id}`;
                    $scope.dirty[dictionary.id] = false;

                    dragularService(bag, {
                        containersModel: [dictionary.items],
                    });
                });

                // odświeżamy accordion
                angular.element('.dictionaries').attr('data-uk-accordion', '{collapse: true, showfirst: false}');
                UIkit.rebuild('accordion');
            }, 250);
        });
    };
    $scope.loadList();

    $scope.addTo = (dictionary) => {
        UIkit.modal.prompt(
            $translate.instant('dictionaries.add_instruction'),
            $translate.instant('new_value'),
            (value) => {
                dictionary.items.push({
                    id: 0,
                    key: '-',
                    value: value,
                });
                $scope.dirty[dictionary.id] = true;
                $scope.$apply();
            },
            {
                labels: {
                    Ok: $translate.instant('save'),
                    Cancel: $translate.instant('cancel'),
                },
            }
        );
    };

    $scope.change = (item, dictionary) => {
        UIkit.modal.prompt(
            $translate.instant('change'),
            item.value,
            (value) => {
                item.value = value;
                $scope.dirty[dictionary.id] = true;
                $scope.$apply();
            },
            {
                labels: {
                    Ok: $translate.instant('change'),
                    Cancel: $translate.instant('cancel'),
                },
            }
        );
    };

    $scope.save = (dictionary) => {
        const info = notify.info($translate.instant('saving'));
        angular.forEach(dictionary.items, (item, i) => {
            item.order = i + 1;
        });
        DictionariesModel.save(dictionary.key, dictionary).then(() => {
            notify.success($translate.instant('saved'));
            info.close();
            DictionariesModel.clearCache();
            $scope.dirty[dictionary.id] = false;
        });
    };
});
